import { useEffect, useRef, useState } from 'react'
import { useInView } from 'framer-motion'

export function useLazyInView(deps: unknown[], reinit: boolean = false) {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref)
  const [hasBeenInView, setHasBeenInView] = useState(false)

  useEffect(() => {
    if (inView) {
      setHasBeenInView(true)
    }
  }, [inView])

  useEffect(() => {
    if (reinit) {
      setHasBeenInView(false)
    }
  }, deps)

  return {
    ref,
    shouldLoad: hasBeenInView,
  }
}
